import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, ArrowLeft, Compass, Search } from "lucide-react";
import { waLink } from "@/lib/constants";

const QUICK_LINKS = [
  { to: "/articole", label: "Articole" },
  { to: "/video", label: "Video" },
  { to: "/petitii", label: "Petiții" },
  { to: "/comunitate", label: "Povești" },
  { to: "/programare", label: "Vorbește cu Gabriel" },
  { to: "/ajutor", label: "Ajutor" },
  { to: "/spune-povestea", label: "Spune povestea ta" },
  { to: "/doneaza", label: "Susține misiunea" },
];

export default function NotFound() {
  const loc = useLocation();
  return (
    <div data-testid="page-404" className="min-h-[70vh] flex items-center">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24 text-center">
        <div className="text-[10px] font-bold tracking-[0.3em] uppercase text-[#E89BB8] mb-4">Pagină inexistentă</div>
        <div className="font-display text-7xl md:text-9xl gold-text leading-none mb-3">404</div>
        <h1 className="font-display text-2xl md:text-4xl text-[#F8F8F4] leading-tight">
          Această cale nu există încă pe TatiSiSofia.ro.
        </h1>
        <p className="font-quote text-lg md:text-xl italic text-[#A0AABF] mt-4 max-w-xl mx-auto">
          „Uneori, pierdem o cărare. Important este să găsim drumul înapoi.”
        </p>
        {loc.pathname && (
          <p className="text-xs text-[#6C7A9C] mt-3 font-mono break-all">URL cerut: {loc.pathname}</p>
        )}
        <div className="mt-9 flex flex-wrap gap-3 justify-center">
          <Link
            to="/"
            data-testid="404-cta-home"
            className="btn-gold rounded-sm px-6 py-3 text-[12px] font-bold tracking-wider inline-flex items-center gap-2"
          >
            <Home className="w-4 h-4" /> ÎNAPOI ACASĂ
          </Link>
          <button
            type="button"
            onClick={() => window.history.back()}
            data-testid="404-cta-back"
            className="btn-gold-outline rounded-sm px-6 py-3 text-[12px] font-bold tracking-wider inline-flex items-center gap-2"
          >
            <ArrowLeft className="w-4 h-4" /> PAGINA ANTERIOARĂ
          </button>
          <a
            href={waLink("Salut, nu am găsit o pagină pe site (404).")}
            target="_blank"
            rel="noreferrer"
            data-testid="404-cta-whatsapp"
            className="btn-ghost-light rounded-sm px-6 py-3 text-[12px] font-bold tracking-wider inline-flex items-center gap-2"
          >
            <Compass className="w-4 h-4" /> CERE AJUTOR
          </a>
        </div>

        <div className="mt-14">
          <div className="text-[10px] font-bold tracking-[0.3em] uppercase text-[#A0AABF] mb-4 flex items-center gap-2 justify-center">
            <Search className="w-3.5 h-3.5" /> Sau caută aici:
          </div>
          <div className="flex flex-wrap gap-2 justify-center">
            {QUICK_LINKS.map((q) => (
              <Link
                key={q.to}
                to={q.to}
                className="px-3 py-2 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-[#D4A63D]/40 text-[12px] text-[#F8F8F4]/85 hover:text-[#D4A63D] rounded-sm tracking-wide transition-colors"
              >
                {q.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
